import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function WeddingHallDashboard() {
  const navigate = useNavigate();
  useEffect(() => { navigate('/wedding-hall/customers', { replace: true }); }, [navigate]);
  return null;
}
